module.exports = __webpack_public_path__ + "assets/images/extra-01.20fa23b7e12865dd87878394c63a6c5c.svg";